var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['loading-overlay', _vm.$root.config.dark ? 'loading-overlay-dark' : null, _vm.visible ? null : 'loading-overlay-hidden']},[_c('div',[_c('v-progress-circular',{attrs:{"indeterminate":"","size":64,"color":_vm.$root.colors.primary}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1746eda","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading-overlay.vue
// module id = null
// module chunks = 